import { configureStore } from '@reduxjs/toolkit';
import { createReduxEnhancer } from '@sentry/react';
import ReduxThunk, { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

import api, { InterpalsWebApi } from 'api';
import rootReducer, { ReduxState } from '../root-reducer';

import { getLocalStorageReduxState, persistToLocalStorage } from './middlewares/localstorage';
import { webSocket } from './middlewares/websocket';
import { sentryReduxMiddleware } from './middlewares/sentry';

const sentryReduxEnhancer = createReduxEnhancer({
    configureScopeWithState: (scope, state: ReduxState) => {
        scope.setTag('user_id', state.account.data?.id);
    },
});

const middlewares = [ReduxThunk.withExtraArgument(api), webSocket, persistToLocalStorage, sentryReduxMiddleware];

/* global process */
if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    const ReduxLogger = require('redux-logger').default;
    middlewares.push(ReduxLogger);
}

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(...middlewares),
    enhancers: [sentryReduxEnhancer],
    preloadedState: getLocalStorageReduxState,
    devTools: process.env.NODE_ENV === 'development',
});

export type RootState = ReturnType<typeof store.getState>;
export type Dispatch = ThunkDispatch<RootState, InterpalsWebApi, Action>;

export default store;
